import { Injectable } from '@angular/core';
import { getProjectModel, newProjectModel, ProjectListModel, ProjectCampaignModel, ProjectModel} from '../models/project.model';
import { newCampaignModel, CampaignModel, DashboardCampaigns } from '../models/campaign.model';
import { MainService } from './main.service';
import { map, Observable, tap } from 'rxjs';
import { UsersService } from './users.service';
import { environment } from 'src/environments/environment';
import jwt_decode from 'jwt-decode';
import { CutoffService } from './cutoff.service';
import { ProjectsService } from './projects.service';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';

@Injectable({
  providedIn: 'root'
})
export class InventorysService {

constructor(
    private main: MainService,
    private usrService : UsersService,
    private cutoffService : CutoffService,
    private projectService : ProjectsService
  ) { 
  }

  isEmpyConfig(json : any) : boolean{
       let empyconfig = true;
       try{
          if(JSON.parse(json)[0].id > 0){
            empyconfig = false;
          }
       }catch(ex){
       }
       return empyconfig;
  }

  //returns
             //inventario totales

             //nombre
             //id_medio
             //id_pop
             //id_pop_config
             //inventario
             //disponible
             //seleccionado
             //precio
             //inventario_type
     getInventory( id_proy : number, id_proy_campana : number, _cutoff: CutoffService, id_medio : any = 0, id_pop : any = 0, filtros_sucursal = [], atributos_sucursal : Array<any>= []){
      return new Promise(async (resolve, reject) => {
        try {
          let dt_totales:any = [];
         this.projectService.getProjectInvTotals(id_proy != 0? id_proy : id_proy_campana, id_proy != 0? false : true).subscribe(
               (result:any) => {
               // this.main.HideLoading();
                if(result.message == "Success") {
                     let columnas_total:any = {};
                     let arr_reglas:any = [];
                     let arr_cant:any = [];
                     const def_fields_stores:any = ["id", "Plaza", "FarmID", "Filial", "Nombre"];
                      console.log("this is all totales", result.totales);
                     result.totales.filter((e:any)=>e.id_medio==(id_medio>0?id_medio:e.id_medio)).map((config:any)=> {
                       let r: any = {};
                       console.log("this is ev config", config, id_medio);
                       if(config.formato == 3) {
                         r = JSON.parse(config.prioridad_filtro)[0];
                         r.cant_type = 4; // de por maximos
                        }
                        else if(config.formato == 2) {
                             r = JSON.parse(config.prioridad_filtro)[0];
                             r.cant_type = 3;
                         }
                         else if(!config.reglas_distribucion || config.reglas_distribucion.length == 0 || config.reglas_distribucion == "[]" || this.isEmpyConfig(config.reglas_distribucion)) {
                             r = {nombre: config.pop_config, cant_type: 1, multiplicador: config.cantidad, id_pop_config: config.id_pc};
                         }
                         else  {
                             r = JSON.parse(config.reglas_distribucion)[0];
                             r.cant_type = 2;
                         }
         
                         r.atributo = r.nombre;
                         r.nombre = config.inventario_type==1?config.medio:(config.inventario_type==2?config.pop:(config.inventario_type==3?config.pop_config:r.atributo));
                         r.pop_config = config.pop_config;
                         r.id_pop_config = config.id_pc;
                         r.medio = config.medio;
                         r.id_medio = config.id_medio;
                         r.id_pop = config.id_pop;
                         r.id_atributo = r.id;
                         r.pop = config.pop;
                         r.pop_config = config.pop_config;
                         r.inventario_type = config.inventario_type;
                         r.pop_sucursales_filtro = config.pop_sucursales_filtro;
                         r.sucursales_filtro = config.sucursales_filtro;
                         r.precio = config.precio;
                         r.prioridad = config.prioridad;
                         r.is_position_type = config.is_position_type;
                         arr_reglas.push(r);
         
                         
                     });
                 
                     let arr_fields_stores:any = [];
                     arr_reglas.map((e:any)=> {
                         if(e.nombre) {
                            arr_fields_stores.push(e.atributo);
                            let obj_config_sel = result.totales.find((t:any)=> {
                              return t.id_pop==(id_pop>0?id_pop:t.id_pop)
                            });
                            obj_config_sel.id_pop_config = obj_config_sel.id_pc;
                            let obj_ins = {
                                 nombre: e.nombre,
                                 atributo: e.atributo,
                                 cantidad: parseInt(e.multiplicador),
                                 tipo: e.cant_type,
                                 inventario_type: e.inventario_type,
                                 medio: e.medio,
                                 pop: e.pop,
                                 pop_config: e.pop_config,
                                 id_medio: e.id_medio,
                                 id_pop: e.id_pop,
                                 config : e.config,
                                 id_pop_config: e.id_pop_config,
                                 id_atributo: e.id_atributo,
                                 sucursales_filtro: e.sucursales_filtro,
                                 pop_sucursales_filtro: e.pop_sucursales_filtro,
                                 precio: e.precio,
                                 is_position_type : e.is_position_type,
                                 prioridad: e.prioridad,
                            }

                            if(id_pop!=0 && e.inventario_type < 3) {

                              obj_ins.precio = obj_config_sel.precio;                
                              obj_ins.pop_sucursales_filtro = obj_config_sel.pop_sucursales_filtro;

                              if(e.inventario_type == 1 && e.cant_type != 2){
                                 obj_ins.pop = obj_config_sel.pop;
                               obj_ins.pop_config = obj_config_sel.pop_config;
                                 obj_ins.id_pop =  obj_config_sel.id_pop;
                               obj_ins.id_pop_config = obj_config_sel.id_pop_config; //se comenta porque se obtienen todos los config por ser id_medio
                                 obj_ins.precio = obj_config_sel.precio;
                                 obj_ins.prioridad = obj_config_sel.prioridad;
                              }
       
                            }

                            //ahora me da igual, subo todos ya que todos son medio
                            if((obj_ins.inventario_type == 1 && obj_ins.tipo == 1)|| e.cant_type == 2){ //si es tipo medio y pero es por cantidad...
                               arr_cant.push(obj_ins);
                           }else{
                              if(!arr_cant.some((ac:any)=> (ac.inventario_type < 3 && ac.id_pop == id_pop))) { //solo inserto uno de cada
                                arr_cant.push(obj_ins);
                              }
                           }

                            

                         }
                     });

                     let  atributosFiltro =  [
                                              ...arr_reglas.map((obj:any) => obj.atributo),
                                              ...filtros_sucursal.map((obj:any) => obj.nombre),
                                              ...arr_reglas.map((obj:any) => JSON.parse(obj.sucursales_filtro?obj.sucursales_filtro:"[]")[0]?.nombre).filter((obj:any)=>obj),
                                              ...arr_reglas.map((obj:any) => JSON.parse(obj.pop_sucursales_filtro?obj.pop_sucursales_filtro:"[]")[0]?.nombre).filter((obj:any)=>obj)
                                            ];
                        atributosFiltro = [...new Set(atributosFiltro)];
                     
                      atributos_sucursal.forEach(attr => {
                        if (!atributosFiltro.includes(attr)) {
                            atributosFiltro.push(attr);
                        }
                      });
                     let filtro = {
                          atributos_nombre: atributosFiltro 
                     }


                     console.log(filtro);
                     _cutoff.getCutOffFile(id_proy_campana, filtro, undefined, true).then(x=>{


                       arr_cant.map((e:any)=> { 
                         let cantidad = 0;
                         let sel_data:any = [];
                         if(e.inventario_type == 1) sel_data = result.data.filter((rd:any)=>rd.id_medio==e.id_medio && rd.id_pop==e.id_pop);
                         if(e.tipo == 3) sel_data = result.data.filter((rd:any)=>rd.id_pop==e.id_pop);
                         if(e.inventario_type == 3) sel_data = result.data.filter((rd:any)=>rd.id_pop_config==e.id_pop_config);
                         if(e.inventario_type == 4) sel_data = result.data.filter((rd:any)=>rd.id_atributo==e.id_atributo);
                    
                         let configs = result.data.filter((rd:any)=>rd.id_medio==e.id_medio);
                        
                          //aqui se agrupan los pops con sus configs
                         let pops = Object.values(
                          configs.reduce((acc : any, item : any) => {
                            if (!acc[item.id_pop]) {
                              acc[item.id_pop] = {
                                id_atributo : item.id_atributo,
                                id_medio : item.id_medio,
                                id_pop : item.id_pop,
                                nombre: item.pop,
                                configs: []
                              
                              };
                            }
                          
                            acc[item.id_pop].configs.push({
                              id_pop_config: item.id_pop_config,
                              id_atributo: item.id_atributo,
                              nombre: item.pop_config,
                              cantidad: item.cantidad
                            });
                          
                            return acc;
                          }, {})
                        );
                        
                          //aqui se agrupan los pops con sus configs
                         let pops_totals = Object.values(
                          configs.reduce((acc : any, item : any) => {
                            if (!acc[item.id_pop]) {
                              acc[item.id_pop] = {
                                id_atributo : item.id_atributo,
                                id_medio : item.id_medio,
                                id_pop : item.id_pop,
                                nombre: item.pop,
                                configs: []
                              };
                            }
                          
                            acc[item.id_pop].configs.push({
                              id_pop_config: item.id_pop_config,
                              id_atributo: item.id_atributo,
                              nombre: item.config,
                              cantidad: item.cantidad,
                            });
                          
                            return acc;
                          }, {})
                        );
                    
                         let columnas_sum:any = {};
                         let filtros:any = [];
                         if(e.pop_sucursales_filtro) filtros = JSON.parse(e.pop_sucursales_filtro);
                         if(e.sucursales_filtro) filtros = [ ...filtros, ...JSON.parse(e.sucursales_filtro)];
                         const storeFile:any = _cutoff.filtrarSucursales(filtros).map((e:any)=>{ 
                           let obj_store:any = {};
                           arr_fields_stores.map((key:string)=> {
                             obj_store[key]= e[key];
                           });
                           return obj_store;
                         });
                      
                         const filtros_max = JSON.parse(e.sucursales_filtro);

                         const storeFile_max:any = _cutoff.filtrarSucursales(filtros_max).map((e:any)=>{ 
                           let obj_store:any = {};
                           arr_fields_stores.map((key:string)=> {
                             obj_store[key]= e[key];
                           });
                           return obj_store;
                         });
                         let cantidad_max = 0;
                         arr_fields_stores.map((key:string)=> {
                           columnas_sum[key] = storeFile.map((e:any)=>e[key]).filter((e:any)=>e).map((e:any)=>parseInt(e)).reduce((a:any, b:any) => a + b, 0);
                         });
         
                         if(e.tipo == 1) {
                           cantidad = storeFile.length*e.cantidad;
                         }else if (e.tipo == 4){
                           //Se supone que e.atributo es el maximo, por lo tanto sumo el valor que trae en el archivo 
                           cantidad = columnas_sum[e.atributo];   
                           const max_aux = storeFile_max.reduce((total: number, sf: any) => {
                           return total + Number(sf[e.atributo]);
                           }, 0)
                           cantidad_max = max_aux * e.cantidad;
                             
                          } 
                          else if (e.tipo == 3) {
                            const cant_pops = arr_reglas.filter((c:any)=>c.id_medio == e.id_medio).map((c:any)=>c.id_pop).filter( this.main.onlyUnique).length;

                            if(cant_pops>1) {
                            storeFile.map((sf:any)=> {
                                const cant_total_suc = (sf[e.atributo]?parseInt(sf[e.atributo]):0)*e.cantidad;
                                const modulo = cant_total_suc%cant_pops;
                                const max = Math.ceil(cant_total_suc/cant_pops);
                                const min = Math.floor(cant_total_suc/cant_pops);
                                cantidad += e.prioridad<=modulo?max:min;   
                              });
                            }
                            else
                              cantidad = columnas_sum[e.atributo]?columnas_sum[e.atributo]*e.cantidad:0;
                          }
                         else {
                           cantidad = columnas_sum[e.atributo]?columnas_sum[e.atributo]*e.cantidad:0;
                         }
         
                         const cantidad_sel_data = sel_data.reduce((total: number, sf: any) => {
                           return total + Number(sf.cantidad);
                           }, 0);
                         
                          const sel = sel_data.length>0?cantidad_sel_data:0;
                          const disp = cantidad-sel;
                          let arr_map_medio = arr_cant.filter((s:any)=> s.id_medio == e.id_medio);
                          let pops_u = Object.values(
                          arr_map_medio.reduce((acc:any, item:any) => {
                              if (!acc[item.id_pop]) {
                              acc[item.id_pop] = {
                                  id_atributo: item.id_atributo,
                                  id_medio: item.id_medio,
                                  id_pop: item.id_pop,
                                  nombre: item.pop,
                                  posiciones: item.posiciones,
                                  configs: [] 
                              };
                              }
                              //recalcular por config
                              let cantidad = 0;
                              if(e.tipo == 1) {
                                cantidad = storeFile.length*e.cantidad;
                              }else if (e.tipo == 4){
                                //Se supone que e.atributo es el maximo, por lo tanto sumo el valor que trae en el archivo 
                                cantidad = columnas_sum[e.atributo];
                                } 
                                else if (e.tipo == 3) {
                                  const cant_pops = arr_reglas.filter((c:any)=>c.id_medio == e.id_medio).map((c:any)=>c.id_pop).filter( this.main.onlyUnique).length;

                                  if(cant_pops>1) {
                                  storeFile.map((sf:any)=> {
                                      const cant_total_suc = (sf[e.atributo]?parseInt(sf[e.atributo]):0)*e.cantidad;
                                      const modulo = cant_total_suc%cant_pops;
                                      const max = Math.ceil(cant_total_suc/cant_pops);
                                      const min = Math.floor(cant_total_suc/cant_pops);
                                      cantidad += e.prioridad<=modulo?max:min;   
                                    });
                                  }
                                  else
                                    cantidad = columnas_sum[e.atributo]?columnas_sum[e.atributo]*e.cantidad:0;
                                }
                              else {
                                cantidad = columnas_sum[e.atributo]?columnas_sum[e.atributo]*e.cantidad:0;
                              }

                              //end calc
                              acc[item.id_pop].configs.push({
                              id_pop_config: item.id_pop_config,
                              id_atributo: item.id_atributo,
                              nombre: item.pop_config,
                              posiciones : item.posiciones,
                              cantidad :cantidad
                              });
                          
                              return acc;
                          }, {})
                          );

                          dt_totales.push({
                             nombre: e.nombre,
                             atributo: e.nombre,
                             inventario: cantidad,
                             inventario_max : cantidad_max,
                             disponible: disp,
                             seleccionado: sel,
                             precio: e.precio,
                             inventario_type: e.inventario_type,
                             id_medio: e.id_medio,
                             id_pop: e.id_pop,
                             pop : e.pop,
                             config : e.pop_config,
                             id_pop_config: e.id_pop_config,
                             id_atributo: e.id_atributo,
                             tipo : e.tipo,
                             pops_totals : pops_totals,
                              pops_t : pops,
                              pops: pops_u
                           }) 
                        });
                        console.log("this is dt_t",dt_totales);
                    if (dt_totales.length > 0) {
                      const acumulados = new Map<number, any>();
                      dt_totales.map((dt: any) => {
                        const id = dt.id_medio;
                        const existente = acumulados.get(id);
                      
                        if (!existente) {
                          acumulados.set(id,{
                            recalc: dt.inventario_type === 1 && dt.tipo === 1,
                            inventario: dt.inventario,
                            seleccionados: dt.seleccionado, 
                          });
                        } else {
                          acumulados.set(id, {
                            recalc: existente.recalc && dt.inventario_type === 1 && dt.tipo === 1,
                            inventario: existente.inventario + dt.inventario,
                            seleccionados: existente.seleccionados, 
                          });
                        }
                      
                        return null; 
                      });
                    
                      dt_totales = dt_totales.map((dt: any) => {
                        const acc = acumulados.get(dt.id_medio)!;
                        if (acc.recalc) {
                          dt.inventario = acc.inventario;
                          dt.disponible = acc.inventario - acc.seleccionados;
                        }
                        return dt;
                      });
                    }
                     resolve(dt_totales);
                    });
                   }
               },
               (err:any) => {
                 this.main.HideLoading();
                 console.log(err);
                 reject(err);
               }
             );
        } catch (error) {
          reject(error)
        }
      });
     }




    //returns {dt_totales}

   getInventory_old( id_proy : number, medio : any, pops : any, configs : any, diagramacion : any){
     this.main.ShowLoading();
     let dt_totales : any = []
     this.projectService.getProjectInvTotals(id_proy).subscribe(
       (result:any) => {
        this.main.HideLoading();
        if(result.message == "Success") {
   
             let columnas_sum:any = {};
             let columnas_total:any = {};
             let arr_reglas:any = [];
             let arr_cant:any = [];
             const def_fields_stores:any = ["id", "Plaza", "FarmID", "Filial", "Nombre"];
             console.log("pure data",result);
             result.totales.filter((e:any)=>e.id_medio== medio.id).map((config:any)=> {
               if(config.formato == 3) {
                 const r = JSON.parse(config.prioridad_filtro)[0];
                 r.cant_type = 4; // de por maximos
                 r.pop_config = config.pop_config;
                 r.precio = config.precio;
                 r.id_pop_config = config.id_pc;
                 arr_reglas.push(r);
                }else if(config.formato == 2) {
                     const r = JSON.parse(config.prioridad_filtro)[0];
                     r.cant_type = 3;
                     r.pop_config = config.pop_config;
                     r.precio = config.precio;
                     r.id_pop_config = config.id_pc;
                     arr_reglas.push(r);
                 }
                 else if(!config.reglas_distribucion || config.reglas_distribucion.length == 0) {
                     const r = {cant_type: 1, multiplicador: 1, id_pop_config: config.id_pc, pop_config: config.pop_config, precio: config.precio};
                     arr_reglas.push(r);
                 }
                 else {
                     const r = JSON.parse(config.reglas_distribucion)[0];
                     r.cant_type = 2;
                     r.pop_config = config.pop_config;
                     r.precio = config.precio;
                     r.id_pop_config = config.id_pc;
                     arr_reglas.push(r);
                 }
             });
             
             let arr_fields_stores:any = [];
             arr_reglas.map((e:any)=> {
               if(e.nombre) {
                 arr_fields_stores.push(e.nombre);
                 const obj_config_sel = result.totales.find((t:any)=> {
                   const rd = t.reglas_distribucion?JSON.parse(t.reglas_distribucion):[];
                   return t.id_pop== pops.id && (rd.length==0||rd.some((r:any)=>r.nombre==e.nombre))
                 });
                 const obj_curr_precio = diagramacion?diagramacion.pop_config.find((pc:any)=> pc.id_pop_config==obj_config_sel.id_pc):null;
   
                 if(!arr_cant.some((ac:any)=> ac.atributo==e.nombre)) {
                   arr_cant.push({
                     pop_config: obj_config_sel?.pop_config?obj_config_sel.pop_config:e.pop_config,
                     id_pop_config: obj_config_sel?.id_pc?obj_config_sel.id_pc:e.id_pop_config,
                     atributo: e.nombre,
                     cantidad: parseInt(e.multiplicador),
                     tipo: e.cant_type,
                     precio: obj_curr_precio&&obj_curr_precio.precio?obj_curr_precio.precio:obj_config_sel?.precio
                   });
                 }
               }
             });
             const arr_fields_totals = arr_fields_stores;
             arr_fields_stores = def_fields_stores.concat(arr_fields_stores);
             
             let filtros:any = [];
             if(result.totales.pop_sucursales_filtro) filtros = JSON.parse(result.totales.pop_sucursales_filtro);
             if(result.totales.sucursales_filtro) filtros = [ ...filtros, ...JSON.parse(result.totales.sucursales_filtro)];
             
             const storeFile:any = this.cutoffService.filtrarSucursales(filtros).map((e:any)=>{ 
                 let obj_store:any = {};
                 arr_fields_stores.map((key:string)=> {
                 
                   if(arr_reglas.some((reg:any) => reg.cant_type === 4)){
                     //reglas tipo 4
                     obj_store[key]= e[key] || 0;
                   }else{
                     obj_store[key]= e[key] || 0;
                   }
   
                 });
                 return obj_store;
             });
   
             arr_fields_stores.map((key:string)=> {
               columnas_sum[key] = this.cutoffService.project_cutoff_file_data.map((e:any)=>e[key]).filter((e:any)=>e).map((e:any)=>parseInt(e)).reduce((a:any, b:any) => a + b, 0);
             });
             arr_cant.map((e:any)=> { 
                 let cantidad = 0;
                 let sel_data = result.data.find((rd:any)=>rd.pop==e.pop_config);
                 if(e.tipo == 1) {
                   cantidad = storeFile.length*e.cantidad;
                 }else if (e.tipo == 4){
                  //Se supone que e.atributo es el maximo, por lo tanto sumo el valor que trae en el archivo 
                  cantidad = storeFile.reduce((total: number, sf: any) => {
                   return total + Number(sf[e.atributo]);
                   }, 0);
                 } 
                 else {
                   cantidad = columnas_sum[e.atributo]?columnas_sum[e.atributo]*e.cantidad:0;
                 }
                 const sel = sel_data?sel_data.cantidad:0;
                 const disp = cantidad-sel;
                 // const curr_config = result.totales.find((t:any)=> {
                 //   const reglas = t.reglas_distribucion?JSON.parse(t.reglas_distribucion):[];
                 //   t.id_pop==this.pop_sel.id
                 // })
                 dt_totales.push({
                   id_pop_config: e.id_pop_config,
                   atributo: e.atributo,
                   inventario: cantidad,
                   disponible: disp,
                   seleccionado: sel,
                   precio: e.precio
                 }); 
             });

             //nombre
             //id_medio
             //id_pop
             //id_pop_config
             //inventario
             //disponible 
             //seleccionado
             //precio
             //inventario_type
   
             dt_totales = Array.from(
               new Map(dt_totales.map((item: any) => [item.atributo, item])).values()
             );
   
              dt_totales.forEach((total : any) => {
               total.disponible = total.disponible 
               //+ this.findMaterialTotal(total.atributo);
             });
           
           }
       },
       (err:any) => {
         this.main.HideLoading();
         console.log(err);
       }
     );
   }  

    getInventoryGlobal(data : any){
       return this.main.postRequest(data, "/projects/inventory/");
    }
}